import { Link } from 'react-router-dom';
import EmptyState from '@/components/ui/EmptyState';
import type { ReportDigestProps } from './types';

export default function ReportDigest({
  reports,
  createLabel,
  createTo,
  emptyTitle = 'No recent reports',
  reportLinkLabel,
}: ReportDigestProps) {
  return (
    <div className="min-w-0">
      {reports.length === 0 ? (
        <EmptyState title={emptyTitle} className="py-10" />
      ) : (
        <ul aria-label="Recent reports" className="divide-y divide-gray-200 dark:divide-gray-800">
          {reports.map((report) => (
            <li key={`${report.type}-${report.id}`}>
              <Link
                to={`/reports/${report.type}/${report.id}`}
                aria-label={reportLinkLabel?.(report) ?? `${report.playerName} ${report.type} report`}
                className="flex min-h-11 w-full max-w-full min-w-0 flex-col items-start gap-2 whitespace-normal break-words rounded-md px-2 py-3 transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 motion-reduce:transition-none dark:hover:bg-gray-800 sm:flex-row sm:items-center sm:justify-between"
              >
                <span className="min-w-0 w-full sm:flex-1">
                  <span className="block break-words text-sm font-semibold text-gray-900 dark:text-gray-100">{report.playerName}</span>
                  <span className="mt-1 block break-words text-xs capitalize text-gray-600 dark:text-gray-400">{report.type} report by {report.authorName}</span>
                </span>
                <time dateTime={report.date} className="max-w-full break-all text-xs tabular-nums text-gray-500 dark:text-gray-400">{report.date}</time>
              </Link>
            </li>
          ))}
        </ul>
      )}
      {createLabel && createTo && (
        <Link
          to={createTo}
          className="mt-3 inline-flex min-h-11 w-full max-w-full items-center justify-center whitespace-normal break-words rounded-md px-3 text-center text-sm font-semibold text-club-blue-700 transition-colors hover:bg-club-blue-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 motion-reduce:transition-none dark:text-club-blue-300 dark:hover:bg-club-blue-950 sm:w-auto"
        >
          {createLabel}
        </Link>
      )}
    </div>
  );
}
